import React from 'react';
import { Checkbox } from '@app/react-common/components/checkbox/Checkbox';

interface DeliveryMethodsTableHeaderProps {
  showCheckbox?: boolean;
  allSelected?: boolean;
  someSelected?: boolean;
  onSelectAll?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export const DeliveryMethodsTableHeader = ({
  showCheckbox = true,
  allSelected = false,
  someSelected = false,
  onSelectAll,
  disabled = false,
  className = 'delivery-methods-list',
}: DeliveryMethodsTableHeaderProps) => {
  return (
    <div className={`${className}__main-content__table-header`}>
      {showCheckbox && (
        <div className={`${className}__table-column ${className}__table-column--checkbox`}>
          {onSelectAll && (
            <Checkbox checked={allSelected} indeterminate={someSelected} onChange={onSelectAll} disabled={disabled} />
          )}
        </div>
      )}
      <div
        className={`${className}__table-column ${className}__table-column--identity ${
          showCheckbox ? '' : `${className}__table-column--identity-without-checkbox`
        }`}>
        Internal name, Type, ID
      </div>
      <div className={`${className}__table-column ${className}__table-column--checkout-name`}>
        Name shown in checkout
      </div>
      <div className={`${className}__table-column ${className}__table-column--conditions`}>Display conditions</div>
      <div className={`${className}__table-column-small`}>Rate</div>
      <div className={`${className}__main-content__actions`} />
    </div>
  );
};
